module.exports = __webpack_public_path__ + "static/fonts/Oswald-Light.8dece29.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Oswald/Oswald-Light.ttf
// module id = 1164
// module chunks = 5